//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import { STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import ArtsCarouselFuturesCategories from "@/components/art/CarouselFuturesCategories.vue";
import MainShowMoreBtn from '@/components/MainShowMoreBtn.vue';

const PAGE_SIZE = 12

export default {
  name: "MainArts",
  components: { ObjectSnippet, ArtsCarouselFuturesCategories, MainShowMoreBtn },

  props: {
    categoryId: {
      type: [Number, String],
      default: null,
    },
    categoryPage: {
      type: Boolean,
      default: false,
    },
    categorySubtree: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      slicedArts: [],
      topList: [],
      bottomList: [],
      artsViewCount: 4,
      swapedBtnToLink: false,
      loadingMore: false,
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
    }
  },

  computed: {
    mainArts() {
      return this.$store.getters['art/getMainArts'];
    },
    mainArtsTotal() {
      return this.$store.getters['art/getMainArtsTotal'];
    },
    showMoreBtn() {
      if (!this.categoryPage) {
        return true
      }
      const total = this.mainArtsTotal || this.mainArts.length
      return this.slicedArts.length < total
    },
  },

  watch: {
    slicedArts(newVal) {
      this.topList = newVal.slice(0, this.artsViewCount / 2)
      this.bottomList = newVal.slice(this.artsViewCount / 2)
    },

    artsViewCount(newVal) {
      this.slicedArts = this.mainArts.slice(0, newVal)

      this.swapedBtnToLink = false
    },

    mainArts() {
      if (this.categoryPage && this.slicedArts.length) {
        this.syncSlicedArts()
      }
    },
  },

  created() {
    this.slicedArts = this.mainArts.slice(0, this.artsViewCount)
  },

  mounted(){
    this.updateArtsViewCount()
    this.slicedArts = this.mainArts.slice(0, this.artsViewCount)

    window.addEventListener('resize', this.updateArtsViewCount, { passive: true })
  },

  destroyed() {
    window.removeEventListener('resize', this.updateArtsViewCount)
  },

  methods: {
    updateArtsViewCount() {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 1600 ) {
          this.artsViewCount = 8
        } else if (window.innerWidth >= 1200) {
          this.artsViewCount = 8
        } else if (window.innerWidth >= 640) {
          this.artsViewCount = 4
        } else {
          this.artsViewCount = 6
        }
      }
    },

    getShowMoreIncrement() {
      return window.innerWidth < 640 ? 3 : this.artsViewCount / 2
    },

    syncSlicedArts() {
      const increment = this.getShowMoreIncrement()
      const nextCount = Math.min(
        this.slicedArts.length + this.artsViewCount + increment,
        this.mainArts.length
      )
      this.slicedArts = this.mainArts.slice(0, nextCount)
    },

    async addMoreArts() {
      if (this.categoryPage) {
        await this.addMoreArtsCategoryPage()
        return
      }

      this.slicedArts = this.mainArts.slice(0, this.artsViewCount + this.getShowMoreIncrement())
      this.swapedBtnToLink = true
    },

    async addMoreArtsCategoryPage() {
      const increment = this.getShowMoreIncrement()
      const nextLocalCount = Math.min(
        this.slicedArts.length + this.artsViewCount + increment,
        this.mainArts.length
      )

      if (nextLocalCount > this.slicedArts.length) {
        this.slicedArts = this.mainArts.slice(0, nextLocalCount)
        return
      }

      const total = this.mainArtsTotal || this.mainArts.length
      if (this.mainArts.length >= total) {
        return
      }

      this.loadingMore = true
      try {
        await this.$store.dispatch('art/getMainArts', {
          category: this.categoryId,
          limit: PAGE_SIZE,
          offset: this.mainArts.length,
          order: '-total_score',
          category_subtree: this.categorySubtree,
        })
        this.syncSlicedArts()
      } finally {
        this.loadingMore = false
      }
    },
  }
}
